/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * A supervisor's broadcast message to the 1:N cohort (P8c).

Surfaced to every student's run-state poll; the client dismisses it locally
keyed by ``issuedAt`` (latest-wins) so it stays until discarded.
 */
export interface OralExamSupervisorBroadcast {
  text: string;
  issuedAt: string;
}
